import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'
import { toLower } from 'lodash'

import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../../common/utils'

interface Medication {
  name: string
  // Add other properties as needed
}

interface EmarMedicationSearchListItemProps {
  medication: Medication
  onClick: () => void
  searchTerm?: string
  testId?: string
}

const renderMedDescription = (props: EmarMedicationSearchListItemProps) => {
  const { medication, searchTerm } = props

  if (!medication || !medication.name || !searchTerm) return null

  const description = medication.name
  const searchTermIndex = toLower(description).indexOf(toLower(searchTerm))

  if (searchTermIndex !== null && searchTermIndex !== -1) {
    const substring1 = description.substring(0, searchTermIndex)
    const substring2 = description.substring(
      searchTermIndex,
      searchTermIndex + searchTerm.length
    )
    const substring3 = description.substring(
      searchTermIndex + searchTerm.length
    )

    return (
      <div>
        <span>{substring1}</span>
        <span className={css(classes.boldText)}>{substring2}</span>
        <span>{substring3}</span>
      </div>
    )
  }

  return <div>{description}</div>
}

/**
 * Renders a medication in the Add Med search list.
 *
 * @param medication - A medication object.
 * @param onClick - Fires when the item is clicked.
 * @param searchTerm - The search term.
 *
 * @returns {React.ReactNode} EmarMedicationSearchListItem
 */
const EmarMedicationSearchListItem: React.FC<
  EmarMedicationSearchListItemProps
> = (props) => {
  const { onClick, testId } = props

  return (
    <div
      onClick={onClick}
      className={css(classes.searchResult)}
      data-testid={testId ? `${testId}-search-list-item` : 'search-list-item'}
    >
      {renderMedDescription(props)}
    </div>
  )
}

const classes = StyleSheet.create({
  boldText: {
    fontWeight: 700
  },
  searchResult: {
    padding: 8,
    cursor: 'pointer',
    ':hover': {
      background: hexToRgbA(colors.blue, 0.25),
      transition: 'all .1s'
    }
  }
})

export default EmarMedicationSearchListItem
